import type { SystemServiceGroup } from '@develop/ia-api-library'
import { getSystemServices } from '@develop/ia-api-library'

export const useSystemServicesFilters = () => useAsyncData('apofinder:system-services', async () => {
  const { data, success, message } = await getSystemServices()

  if (!success) {
    onShowLogs(() => console.error('Error fetching system services', message))
  }

  // Sort by displayOrder
  return (data ?? []).sort((a, b) => a.displayOrder - b.displayOrder)
}, {
  getCachedData: getCachedData<SystemServiceGroup[]>,
})
